import { AfterViewInit, Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { SettingsService } from 'src/app/shared/services/settings';
import { AccountsService } from 'src/app/shared/services/accounts/accounts.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LtmsLoaderComponent } from 'src/app/shared/components/ltms-loader/ltms-loader.component';
import * as _ from 'lodash'
import { CommonModule, NgClass, NgFor, NgIf } from '@angular/common';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { FormsModule } from '@angular/forms';

interface PropertyValue {
  control: 'textbox' | 'dropdown';
  type?: string;
  value?: string;
  options: string[];
}

interface PropertyData {
  [key: string]: PropertyValue;
}

@Component({
  selector: 'app-litmus-intraction-preview',
  templateUrl: './litmus-intraction-preview.component.html',
  styleUrl: './litmus-intraction-preview.component.scss',
  standalone: true,
  imports: [NgClass, NgIf, NgFor, FormsModule, CommonModule, LtmsLoaderComponent]
})
export class LitmusIntractionPreviewComponent implements OnInit, AfterViewInit {
  @Output() close: any = new EventEmitter<any>();
  @Input() isModalView: boolean = false
  previewDevice: 'phone' | 'tablet' | 'desktop' = 'desktop';
  default_language: string = '';
  deviceType: 'phone' | 'tablet' | 'desktop' = 'phone';
  configuration: any = {};
  propertyData: PropertyData = {};
  url = '';
  previewUrl = '';
  activeTab: 'basic' | 'advanced' = 'basic';
  projectId: string = '';
  version: string = ''
  brandDetails: any = null;
  isViewLoaded: boolean = false;
  isLoading: boolean = true
  isUrlLoaded:boolean = false;
  isCopyEnabled:boolean = false;
  constructor(
    private _settings: SettingsService,
    private _route: ActivatedRoute,
    private _accountService: AccountsService,
    private _helpers:HelpersService
  ) { }

  ngOnInit(): void {
    this.isViewLoaded = false;
    this.isLoading = true;
    this._route.queryParams.subscribe((params: any) => {
      this.projectId = params?.project_id
      this.version = params?.version
      if (this.projectId && this.projectId != '') {
        this._accountService.getBrandDetail(this.projectId).subscribe(response => {

          if (response?.data?.code == 0 && !_.isEmpty(response?.data?.brand)) {
            this.brandDetails = response?.data?.brand;
            this.getConfiguration(this.projectId, this.version).then((isConfigAvailable) => {
              if (isConfigAvailable) {
                this.url = this.getPreviewUrl();
                this.isLoading = false;
                this.isUrlLoaded = true;
                if (this.isViewLoaded) {
                  this.setPreviewUrl(this.url)
                }
              }
              this.isLoading = false;
            })
          } else {
            this.isLoading = false;
          }
        })
      } else {
        this.isLoading = false;
      }


    })
  }

  ngAfterViewInit(): void {
    this.isViewLoaded = true;
    if (this.url != '') {
      setTimeout(() => {
        // this.setPreviewUrl(this.url);
      }, 100)
    }

  }



  getConfiguration(brandId: string, version?: string) {
    return new Promise((resolve, reject) => {
      if (!version || this.version == '') {
        this._settings.getFeedbackConfiguration(brandId).subscribe((response: any) => {
          if (response && response?.data?.code == 0 && _.has(response, 'data.brand_configuration')) {
            this.configuration = response.data.brand_configuration[0] || {};
            this.default_language = this.configuration.default_language
            // this.previewDevice = this.configuration.default_device;
            this.getFields()
            resolve(true)
          } else {
            resolve(false)
          }
        })
      } else {
        this._settings.getFeedbackConfigurationByVersion(brandId, version).subscribe((response: any) => {
          if (response && response?.data?.code == 0 && _.has(response, 'data.brand_configuration')) {
            this.configuration = response.data.brand_configuration[0] || {};
            this.default_language = this.configuration.default_language
            // this.previewDevice = this.configuration.default_device;
            this.getFields()
            resolve(true)
          } else {
            resolve(false)
          }
        })
      }
    })


  }

  setActiveTab(tab: 'basic' | 'advanced') {
    this.activeTab = tab;
  }

  isConfigPanelOpen:boolean = false;
  showAdvancedConfig(){
    this.isConfigPanelOpen = true;
  }
  hideAdvancedConfig(){
    this.isConfigPanelOpen = false;
  }

  closeModal() {
    this.close.emit()
  };

  isEnableAdvanceTab() {
    return Object.keys(this.propertyData).length;
  };

  displayPreviewUrl() {
    setTimeout(() => {
      this.setPreviewUrl(this.getPreviewUrl());
    }, 100);
  }

  setPreviewUrl(url, device?: any) { 
    this.previewDevice = device ? device : 'desktop';
    this.url = device ? this.updateUrlParameter(url, 'device', device) : url;
    const conversationPreviewIframeModal = document.getElementById('conversationPreviewIframeModal');
    if (conversationPreviewIframeModal)
      conversationPreviewIframeModal.setAttribute('src', this.url)

    const conversationPreviewIframeModalAdvance = document.getElementById('conversationPreviewIframeModalAdvance');
    if (conversationPreviewIframeModalAdvance)
      conversationPreviewIframeModalAdvance.setAttribute('src', this.url)
  };

  isCopied: boolean = false;
  copyToClipboard() {
    try {
      navigator.clipboard.writeText(this.url);
      this.isCopied = true;
      this._helpers.smallAlertBox('Success', 'Preview link copied to clipboard', 'success', 3000);
      setTimeout(() => {
        this.isCopied = false;
      }, 3000);
    } catch (error) {
      this.isCopied = false;
      this._helpers.smallAlertBox('Error', 'Failed to copy preview link', 'error', 3000);
    }
  }

  isPrimaryRatingExist: boolean = false;
  isPrimaryCommentExist: boolean = false;
  getFields() {
    var brandId = this.brandDetails._id;
    if (!_.isEmpty(this.configuration)) {
      var fields = this.configuration.fields;
      _.each(fields, (value, index) => {
        if(value.field_id == "primary_rating"){
          this.isPrimaryRatingExist = true;
        }
        if(value.field_id == "comments"){
          this.isPrimaryCommentExist = true;
        }

        if (value.hasOwnProperty("server-visible-if")) {
          this.processExpression(value["server-visible-if"]);
        }
      });
      var languages = this.configuration.languages;
      _.each(languages, (value, index) => {
        if (value.hasOwnProperty("dynamic_labels")) {
          _.each(value.dynamic_labels, (dynamicValue, index) => {
            _.each(dynamicValue, (dLabel, index) => {
              if (dLabel.hasOwnProperty("condition")) {
                this.processExpression(dLabel["condition"]);
              }
            });
          });
        }
      });
    }
  }
  /** Process the expresssion - mainly splitting words based on regex*/
  processExpression(val) {
    val = val || '';
    val = val.replace(/"/g, "'");
    var splitByAndOr = val.split(/["&|\[\]\r\n/\\]+/);
    _.each(splitByAndOr, (value, index) => {
      value = value.trim();
      var splitByEqual = value.split(/[!="()<>{}\[\]\r\n/\\]+/);
      if (splitByEqual.length === 2) {
        this.setProperty(splitByEqual[0].trim(), splitByEqual[1].trim());
      }
    });

    setTimeout(() => {
      this.findControlType();
    }, 100);
  }

  setProperty(key: string, value: string) {
    value = value.replace(/["']/g, "");
    if (this.propertyData && this.propertyData.hasOwnProperty(key)) {
      this.propertyData[key].options.push(value);
      this.propertyData[key].options = _.uniq(this.propertyData[key].options);
    } else {
      this.propertyData[key] = {
        control: 'dropdown',
        options: [value]
      };
    }
  }

  findControlType() {
    for (var key in this.propertyData) {
      if (this.propertyData.hasOwnProperty(key)) {
        var count = this.propertyData[key].options.length;
        for (var k = 0; k < this.propertyData[key].options.length; k++) {
          var opt = parseInt(this.propertyData[key].options[k]);
          if (!isNaN(opt)) {
            count -= 1;
            break;
          }
        }
        this.propertyData[key]['control'] = this.propertyData[key].options.length === count ? 'dropdown' : 'textbox';
      }
    }
  }

  generateUrl() {
    _.each(this.propertyData, (val, key) => {
      if (key && val.value) {
        var regex = new RegExp('[?&]' + key + '=', 'g');
        if (regex.test(this.url)) {
          this.url = this.updateUrlParameter(this.url, key, val.value);
        } else {
          this.url += "&" + key + "=" + val.value;
        }
      } else {
        this.url = this.removeParam(this.url, key);
      }
    });
    this.setPreviewUrl(this.url);
  }
  clearPropertyValues(){
    _.each(this.propertyData, (val, key) => {
      this.propertyData[key].value = ''
      val.value = ''
      this.url = this.removeParam(this.url, key);
    });
    this.setPreviewUrl(this.url);
  }

  // Update query params
  updateUrlParameter(uri, key, value) {
    // remove the hash part before operating on the uri
    var i = uri.indexOf('#');
    var hash = i === -1 ? '' : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";

    if (!value) {
      // remove key-value pair if value is empty
      uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), '');
      if (uri.slice(-1) === '?') {
        uri = uri.slice(0, -1);
      }
      // replace first occurrence of & by ? if no ? is present
      if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
    } else if (uri.match(re)) {
      uri = uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
      uri = uri + separator + key + "=" + value;
    }
    return uri + hash;
  };

  removeParam(uri, key) {
    var result = uri.split("?")[0],
      param,
      params_arr: any = [],
      queryString = (uri.indexOf("?") !== -1) ? uri.split("?")[1] : "";
    if (queryString !== "") {
      params_arr = queryString.split("&");
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split("=")[0];
        if (param === key) {
          params_arr.splice(i, 1);
        }
      }
      result = result + "?" + params_arr.join("&");
    }
    return result;
  };


  errorMessage:string = 'No pages has been configured for';
  flowByDeaviceAndLang(device, lang) {
    let flag: boolean = false;
    this.isCopyEnabled = false;
    this.errorMessage = 'No pages has been configured for';
    if (_.hasIn(this.configuration, 'flows.' + device + "." + lang) && !_.isEmpty(this.configuration?.flows[device][lang])) {
      // commeted because its not required for now, we can add it back if needed
      // if(this.isPrimaryRatingExist || this.isPrimaryCommentExist){
      //   const {primaryComment, primaryRating} = this.checkifQuestionExist(this.configuration.screens[device][lang]);
      //   let primaryRatingAvailable = (this.isPrimaryRatingExist && primaryRating)?true:false;
      //   let primaryCommentAvailable = (this.isPrimaryCommentExist && primaryComment)?true:false;
      //   if(primaryRatingAvailable && primaryCommentAvailable ){
      //     flag = true;
      //   }else if(!this.isPrimaryCommentExist && primaryRatingAvailable){
      //     flag = true;
      //   }else if(!this.isPrimaryRatingExist &&primaryCommentAvailable){
      //     flag = true;
      //   }else{
      //     if(!primaryRatingAvailable && !primaryCommentAvailable){
      //       this.errorMessage = 'primary rating and comment is not added into pages  for ';
      //     }else if(this.isPrimaryRatingExist && !primaryRating){
      //       this.errorMessage = 'primary rating is not added into pages  for ';
      //     }else if(this.isPrimaryCommentExist && !primaryComment){
      //       this.errorMessage = 'primary comment is not added into pages  for ';
      //     }
      //     flag = false;
      //   }
      // }else{
      //   flag = true;  
      // }
      flag = true;
    }
    if(flag && this.isUrlLoaded){
      this.isUrlLoaded = false; 
      this.displayPreviewUrl()
    }
    this.isCopyEnabled  = flag;
    return flag;
  }

  getPreviewUrl(isCopy?: boolean) {
    // Changes by Bhunesh - 16th Feb 2017 - removing device parameter in case of copying link
    var configVersion = this.configuration.version;
    var brandId = this.brandDetails._id;
    //Modified - Shigufa - [LP20091724501] Bug - Preview link Url not copied in browser .(For the newly created project)
    var configUrl = (this.brandDetails.conversation_config.feedbacks['url']) ? this.getConfigBaseUrl(this.brandDetails.conversation_config.feedbacks['url'], 'v2/') : environment.base_url;
    var url = configUrl + "preview-v2/" + brandId + "?config=" + configVersion;
    if (isCopy) {
      return url;
    } else {
      // Added by Bhunesh - 3rd Feb 2017 - Preview link URL changes to view preview without publish
      return url + "&device=" + this.previewDevice;
    }
  }
  checkifQuestionExist(flows:any){
    let primaryComment: boolean = false;
    let primaryRating: boolean = false;
    if(flows && flows.length>0){
      const questions:any = _.flatten(_.map(flows,(flow:any)=>{
        return flow.fields || []
      }))
       let comeentQuestion = _.find(questions, (question: any) => question.field_id == 'comments');
       let ratingQuestion = _.find(questions, (question: any) => question.field_id == 'primary_rating');
       if(comeentQuestion){
        primaryComment = true;
       }
       if(ratingQuestion){
        primaryRating = true;
       }
    }
    return {
      primaryComment,
      primaryRating
    }
  }

  getConfigBaseUrl(url, text_exclude) {
    return url.replace(text_exclude, '');
  }
}
